import axiosClient from './axiosClient';

const rentalApi = {
  // Partners (hồ sơ đối tác cho thuê xe)
  getPartners: (params) => axiosClient.get('/rentals/partners', { params }),
  getPartner: (rentalPartnerId) => axiosClient.get(`/rentals/partners/${rentalPartnerId}`),
  approvePartner: (rentalPartnerId) => axiosClient.post(`/rentals/partners/${rentalPartnerId}/approve`),
  rejectPartner: (rentalPartnerId, reason) => axiosClient.post(`/rentals/partners/${rentalPartnerId}/reject`, { reason }),

  // Vehicles + deposit transactions
  getVehicle: (rentalVehicleId) => axiosClient.get(`/rentals/vehicles/${rentalVehicleId}`),
  getDepositTransactions: (params) => axiosClient.get('/rentals/vehicles/deposit-transactions', { params }),
  confirmDeposit: (rentalDepositTransactionId, body) => axiosClient.post(
    `/rentals/vehicles/deposit-transactions/${rentalDepositTransactionId}/confirm`,
    body,
  ),
  rejectDeposit: (rentalDepositTransactionId, reason) => axiosClient.post(
    `/rentals/vehicles/deposit-transactions/${rentalDepositTransactionId}/reject`,
    { reason },
  ),
  getExpiredContracts: () => axiosClient.get('/rentals/vehicles/expired-contracts'),
  refundDeposit: (rentalVehicleId) => axiosClient.post(`/rentals/vehicles/${rentalVehicleId}/refund-deposit`),

  // Vehicle model catalog (model + ảnh + giá trị xe tham chiếu, đối tác
  // chọn từ đây khi thêm xe thay vì tự gõ)
  getVehicleModels: () => axiosClient.get('/rentals/vehicle-models'),
  createVehicleModel: (body) => axiosClient.post('/rentals/vehicle-models', body),
  updateVehicleModel: (rentalVehicleModelId, body) => axiosClient.put(`/rentals/vehicle-models/${rentalVehicleModelId}`, body),
  deleteVehicleModel: (rentalVehicleModelId) => axiosClient.delete(`/rentals/vehicle-models/${rentalVehicleModelId}`),

  // Renter licenses (GPLX khách thuê)
  getRenterLicenses: (params) => axiosClient.get('/rentals/renter-licenses', { params }),
  getRenterLicense: (rentalRenterLicenseId) => axiosClient.get(`/rentals/renter-licenses/${rentalRenterLicenseId}`),
  approveRenterLicense: (rentalRenterLicenseId) => axiosClient.post(`/rentals/renter-licenses/${rentalRenterLicenseId}/approve`),
  rejectRenterLicense: (rentalRenterLicenseId, reason) => axiosClient.post(
    `/rentals/renter-licenses/${rentalRenterLicenseId}/reject`,
    { reason },
  ),

  // Orders (đơn thuê xe)
  getOrders: (params) => axiosClient.get('/rentals/orders', { params }),
  getOrder: (rentalOrderId) => axiosClient.get(`/rentals/orders/${rentalOrderId}`),

  // Damage reports (báo cáo hư hỏng)
  getDamageReports: (params) => axiosClient.get('/rentals/damage-reports', { params }),
  getDamageReport: (rentalDamageReportId) => axiosClient.get(`/rentals/damage-reports/${rentalDamageReportId}`),
  resolveDamageReport: (rentalDamageReportId, resolutionNote) => axiosClient.post(
    `/rentals/damage-reports/${rentalDamageReportId}/resolve`,
    { resolutionNote },
  ),

  // Reconciliation (đối soát doanh thu)
  previewReconciliation: (params) => axiosClient.get('/rentals/reconciliations/preview', { params }),
  getReconciliations: (params) => axiosClient.get('/rentals/reconciliations', { params }),
  createAndApproveReconciliation: (body) => axiosClient.post('/rentals/reconciliations', body),
};

export default rentalApi;
